import React from "react";
import { Box, TextField, Button, Typography, InputAdornment } from "@mui/material";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

// Styled components
const HeaderContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: "#fff",
    borderRadius: "8px 8px 0 0",
    boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
}));

const SearchField = styled(TextField)(({ theme }) => ({
    flex: 1,
    marginRight: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
        borderRadius: 8,
        '&:hover fieldset': {
            borderColor: theme.palette.primary.main,
        },
    },
}));

const AddButton = styled(Button)(({ theme }) => ({
    height: 48,
    borderRadius: 8,
    padding: theme.spacing(0, 3),
    backgroundColor: "#2C5283",
    boxShadow: "0 4px 10px rgba(44, 82, 131, 0.15)",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
        backgroundColor: "#1A365D",
        boxShadow: "0 6px 15px rgba(44, 82, 131, 0.25)",
    },
}));

const PageTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    color: "#2C5283",
    marginBottom: theme.spacing(2),
}));

const PropertyHeader = ({ searchQuery, onSearchChange, onAddProperty }) => {
    return (
        <Box>
            <PageTitle variant="h5">Property Management</PageTitle>
            <HeaderContainer>
                <SearchField
                    id="search-properties"
                    placeholder="Search by property name, location..."
                    variant="outlined"
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon color="action" />
                            </InputAdornment>
                        ),
                    }}
                    size="medium"
                />
                <AddButton
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={onAddProperty}
                >
                    Add Property
                </AddButton>
            </HeaderContainer>
        </Box>
    );
};

export default PropertyHeader;